import { type Dispatch } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { type Action, type MessagesWizard } from '#types/chat/index.ts'

interface SubmitCreateConversationProps {
	message?: string
	messageFetcher: any
	dispatch: Dispatch<Action>
	messages?: MessagesWizard
	typeOfView: string
}

export const createConversation = async ({
	message,
	dispatch,
	messageFetcher,
	messages,
	typeOfView,
}: SubmitCreateConversationProps) => {
	const formData = new FormData()
	const newConversationId = uuidv4()
	const newMessageId = uuidv4()

	formData.append('_action', 'create_conversation')
	formData.append('conversationId', newConversationId)
	formData.append('messageId', newMessageId)
	formData.append('typeOfView', typeOfView)
	formData.append('title', 'New Chat')

	if (message) {
		formData.append('message', message)
		dispatch({
			type: 'CREATE_CONVERSATION',
			updatedAt: new Date().toISOString(),
			conversationId: newConversationId,
			messageId: newMessageId,
			title: 'New Chat',
			message,
		})
	}

	if (messages) {
		formData.append('messages', JSON.stringify(messages))
		dispatch({
			type: 'CREATE_CONVERSATION',
			updatedAt: new Date().toISOString(),
			conversationId: newConversationId,
			messageId: newMessageId,
			title: 'New Chat',
			messages,
		})
	}

	await messageFetcher.submit(formData, {
		method: 'post',
	})
}
